export const inr = (value) =>
  `₹ ${Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;

export const inrShort = (value) => {
  const n = Number(value || 0);
  if (n >= 10000000) return `₹ ${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(2)} L`;
  return inr(n);
};

export const num = (value) => Number(value || 0).toLocaleString("en-IN");

export const dmy = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Asia/Kolkata" });
};

export const dmyTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata",
  });
};

export const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

export const titleize = (s) =>
  String(s || "").replace(/[._]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const BUSINESS_TYPE_LABEL = {
  hospital: "Hospital",
  pharmacy: "Pharmacy",
  hospital_pharmacy: "Hospital + Pharmacy",
};
